<template>
  <div>
    <br />

    <CCard>
      <CCardHeader>
        <h5>Profile</h5>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/card-components"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <!-- <small class="text-muted">docs</small> -->
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="6" lg="5" style="text-align: center">
            <CCol>
              <span style="text-align: center !important; font-weight: 700"
                >TAKE SELFIE / UPLOAD PROFILE</span
              >
              <br />
              <br />

              <img
                src="@/assets/images/profile-avatar.png"
                style="width: 50%"
              />
            </CCol>
            <br />
            <CRow>
              <CCol @click="onFileChange()">
                <!-- <CIcon name="cil-folder-open" /> -->
                <i
                  class="fa fa-folder-open"
                  style="font-size: 18px; float: right"
                >
                  &nbsp;

                  <span style="font-size: 16px">Picture</span></i
                >
              </CCol>
              <CCol style="">
                <i
                  class="fa fa-camera"
                  aria-hidden="true"
                  style="font-size: 15px; float: left"
                >
                  &nbsp;
                  <span style="font-size: 16px">Take Selfie</span>
                </i>
              </CCol>
            </CRow>
          </CCol>
          <CCol md="6" lg="6">
            <br />
            <br />

            <!-- <CRow> -->
            <CInput
              placeholder="First Name"
              style="width: 324px"
              v-model="firstName"
              autocomplete="username email"
            >
              <template #prepend-content>
                <CIcon name="cil-user" />
              </template>
            </CInput>
            <CInput
              placeholder="Last Name"
              v-model="lastName"
              style="width: 324px"
              autocomplete="username email"
            >
              <template #prepend-content>
                <CIcon name="cil-user" />
              </template>
            </CInput>
            <CInput
              placeholder="Email"
              v-model="email"
              style="width: 324px"
              autocomplete="username email"
            >
              <template #prepend-content>
                <CIcon name="cil-envelope-closed" />
              </template>
            </CInput>
            <CInput
              placeholder="Mobile"
              v-model="mobile"
              style="width: 324px"
              autocomplete="username email"
            >
              <template #prepend-content>
                <CIcon name="cil-phone" />
              </template>
            </CInput>
            <!-- <CInput style="width: 324px" label="First Name" />
              <CInput style="width: 324px" label="Last Name" />
              <CInput style="width: 324px" label="Email Name" />
              <CInput style="width: 324px" label="Mobile" /> -->
            <!-- </CRow> -->
            <br />
            <CButton color="success" style="width: 100px">
              <CIcon name="cilCheck" />&nbsp;Save
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { APIService } from "../../../apiservice.js";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      user: [],
      userDetails: [],
      loremIpsum:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.",
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      console.log(this.url);
    },
    getUserInfo() {
      this.user = JSON.parse(localStorage.getItem("user"));
      console.log("User Values", this.user);
      let data = {
        id: this.user.id,
      };
      APIService.getUserDetails(data).then((res) => {
        console.log("Print", res.data.firstName);

        this.firstName = res.data.firstName;
        this.lastName = res.data.lastName;
        this.mobile = res.data.phoneNumber;
        this.email = res.data.email;
      });
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>